import { render, staticRenderFns } from "./SlideError.vue?vue&type=template&id=29aa297c&scoped=true"
import script from "./SlideError.vue?vue&type=script&lang=js"
export * from "./SlideError.vue?vue&type=script&lang=js"
import style0 from "./SlideError.vue?vue&type=style&index=0&id=29aa297c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa297c",
  null
  
)

export default component.exports